import {
  useIsMobile,
  WSElement,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import queryString from "qs";
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch
} from "react-router-dom";

import { Tabs } from "../../../../components/Tabs";
import { BulkImportCollaborators } from "../BulkImportCollaborators";
import { RouteImportPayables } from "../RouteImportPayables";
import styles from "./styles.module.scss";

import { useUrlQueryFilters } from "../../../../utils/router";
import { useAccountAccess } from "../../../../v3/hooks/useAccountAccess";
import { FilterSelectYear } from "../../components/FilterSelectYear";
import {
  BULK_IMPORT_CONTRACTORS_BATCHES,
  PATH_IMPORT_PAYABLES,
  routeHelpersImportPayablesStart,
  useGoToContractorImportStart
} from "../../paths";
import { BulkBatchesFilters } from "../../services/types";

export function BulkImports() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const queries: { year?: string } = queryString.parse(location.search, {
    ignoreQueryPrefix: true
  });
  const { filters } = useUrlQueryFilters<BulkBatchesFilters>({
    year: queries.year
  });
  const { hasScope } = useAccountAccess();

  const goToContractorImportStart = useGoToContractorImportStart();
  const goToPayablesImportStart = routeHelpersImportPayablesStart.useGoTo();

  // The payables tab is on v3, where `listBatches` takes no date filter — the
  // year select would silently do nothing there, so it stays with the
  // still-v1 contractors tab, which does filter on `createdAt`.
  const isContractorsTab = !!useRouteMatch(BULK_IMPORT_CONTRACTORS_BATCHES);

  return (
    <WSPage>
      <WSPageToolbar
        title="Bulk imports"
        titleAfter={
          isContractorsTab ? (
            <FilterSelectYear defaultYear={Number(filters.year)} />
          ) : undefined
        }
        actions={[
          {
            hidden: !hasScope("payments.payable"),
            name: "importPayables",
            buttonKind: "Primary",
            label: "Import payables & deductions",
            onClick: () => {
              goToPayablesImportStart();
            }
          },
          {
            hidden: !hasScope("payments.payee"),
            name: "importContractors",
            label: "Import contractors",
            buttonKind: "Secondary",
            onClick: () => {
              goToContractorImportStart();
            }
          }
        ]}
      />

      <Tabs
        tabs={[
          ...(hasScope("payments.payable")
            ? [
                {
                  path: PATH_IMPORT_PAYABLES,
                  label: "Payables & deductions"
                }
              ]
            : []),
          ...(hasScope("payments.payee")
            ? [
                {
                  path: BULK_IMPORT_CONTRACTORS_BATCHES,
                  label: "Contractors",
                  params: { year: filters.year }
                }
              ]
            : [])
        ]}
      />
      <WSElement mt={isMobile ? "XL" : "L"} className={styles.wrapper}>
        <Switch>
          {hasScope("payments.payable") ? (
            <Route
              path={PATH_IMPORT_PAYABLES}
              component={RouteImportPayables}
            />
          ) : null}
          {hasScope("payments.payee") ? (
            <Route
              path={BULK_IMPORT_CONTRACTORS_BATCHES}
              component={BulkImportCollaborators}
            />
          ) : null}
          <Redirect from="*" to={PATH_IMPORT_PAYABLES} />
        </Switch>
      </WSElement>
    </WSPage>
  );
}
